import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

const AuthRoute = ({ component: Component, authenticated, ...rest }) =>
    authenticated ? <Navigate to="/" /> : <Component {...rest} />;

AuthRoute.prototype = { user: PropTypes.object.isRequired };

const mapStateToProps = (state) => ({ authenticated: state.user.authenticated });

export default connect(mapStateToProps)(AuthRoute);
